import React, { useState } from 'react';
import BACKEND_URL from "./../../config/config.js"
import "../../App.css";

export default function Debug() {
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState(null);

  const simularCompensacion = async () => {

    try {
      const res = await fetch(`${BACKEND_URL}/simulate-compensation`, {
        method: "POST"
      });

      if (!res.ok) throw new Error("Error en la respuesta del servidor");

      const data = await res.json();
      setResultado(data);
      setError(null);

      // Opcional: recargar visualizaciones si querés actualizar paneles automáticos
      // window.location.reload();
    } catch (err) {
      setResultado(null);
      setError("No se pudo simular la compensación.");
      console.error(err);
    }
  };

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>🧪 Panel de debug</h1>

      <button
        onClick={simularCompensacion}
        style={{
          padding: '10px 20px',
          fontSize: '18px',
          cursor: 'pointer',
          marginTop: '20px'
        }}
      >
        Simular compensación automática
      </button>

      {error && <p style={{ color: "red", marginTop: "20px" }}>{error}</p>}

      {resultado && (
        <div style={{ marginTop: '30px', fontSize: '16px' }}>
          {resultado.estado === "ya completo" ? (
            <p>✅ Ya hay suficientes registros ({resultado.registrados}). No se realizó compensación.</p>
          ) : (
            <>
              <p>⚙️ Registros compensados generados: <strong>{resultado.registros_insertados}</strong></p>
              <p>🌱 CO₂ compensado total: <strong>{resultado.co2_total_insertado} kg</strong></p>
            </>
          )}
        </div>
      )}
    </div>
  );
}
